<template>
  <div>
    <div v-for="metadataElement in metadataList">
      <component :is="getMetadataTypeComponentName(metadataElement)"
                 :metadata="metadataElement"
                 :editable="editable"
                  @change="onMetadataChange"></component>
    </div>

  </div>
</template>

<script>
import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from "vue-json-viewer";
import AlphaBetaComponent from "@/valchrom/common/metadata/types/AlphaBetaComponent";
import SpikingComponent from "@/valchrom/common/metadata/types/SpikingComponent"
import CalibrationGraphMultipliers from "@/valchrom/common/metadata/types/CalibrationGraphMultipliers"

@Component({
  components: {
    JsonViewer,
    AlphaBetaComponent,
    SpikingComponent,
    CalibrationGraphMultipliers
  }
})
export default class MetadataComponent extends Vue {

  @Prop() metadataList = [];
  @Prop() editable = true;

  getMetadataTypeComponentName(metadata){
    if(metadata.type==="AlfaBeta"){
      return "AlphaBetaComponent";
    }
    if(metadata.type==="Spiking"){
      return "SpikingComponent"
    }
    if(metadata.type==="CalibrationMultiplier"){
      return "CalibrationGraphMultipliers"
    }
  }

  onMetadataChange(){
    this.$emit("change")
  }
}
</script>

